import Modal from '~/@common/ui/modal/Modal'

const LogoutAfterPasswordChangeModal = ({ onConfirm }: { onConfirm: () => void }) => {
  return (
    <Modal.Alert
      confirm={{
        style: {
          padding: '10px',
        },
        onClick: () => {
          onConfirm()
        },
      }}
    >
      비밀번호가 변경되었습니다.
      <br />
      모든 기기에서 자동으로 로그아웃되니
      <br />새 비밀번호로 다시 로그인해 주세요.
    </Modal.Alert>
  )
}

export default LogoutAfterPasswordChangeModal
